// Whisker Wilds v7 (11/03/2026).
// Shopify Inbox floats its Chat button over the lower right of the screen. On phones it lands on the hero heading.
// While the button covers hero text (heading, intro line, buttons), fade that button out; it comes back as soon as the
// text scrolls away. An open chat window is never touched. Same approach as the Bundle & Save box (fs-bundle.liquid).
(function () {
  var AVOID = '.fs-hero h1, .fs-hero .fs-lede, .fs-hero-actions, .ww-col-hero-card h1, .ww-col-hero-text';
  if (!document.querySelector(AVOID)) return;
  var btn = null, queued = false;
  function find() {
    var host = document.querySelector('shopify-chat'); if (!host || !host.shadowRoot) return null;
    var found = null;
    (function walk(r) {
      found = found || r.querySelector('button.activator');
      if (!found) r.querySelectorAll('*').forEach(function (n) { if (n.shadowRoot && !found) walk(n.shadowRoot); });
    })(host.shadowRoot);
    return found && (found.closest('.activator-nudge') || found);
  }
  function run() {
    queued = false;
    if (!btn || !btn.isConnected) btn = find();
    if (!btn) return;
    var c = btn.getBoundingClientRect(), pad = 8, hit = false;
    if (c.width > 0) {
      document.querySelectorAll(AVOID).forEach(function (el) {
        if (hit) return;
        var w = el.getBoundingClientRect();
        if (w.left < c.right + pad && w.right > c.left - pad && w.top < c.bottom + pad && w.bottom > c.top - pad) hit = true;
      });
    }
    if (hit === btn.wwTucked) return;
    btn.wwTucked = hit;
    btn.style.transition = 'opacity .2s ease-out';
    btn.style.opacity = hit ? '0' : '';
    btn.style.pointerEvents = hit ? 'none' : '';
    if (hit) btn.setAttribute('tabindex', '-1'); else btn.removeAttribute('tabindex');
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  [800, 1500, 3000, 5000, 8000, 15000].forEach(function (ms) { setTimeout(queue, ms); }); // Inbox loads after the page
})();
